import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-marca',
    templateUrl: './marca.component.html',
    styleUrls: ['./marca.component.less'],
    standalone: false
})
export class MarcaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
